/*
  SWIFT — dealer account links (ours: ss-dealer-links)
  Makes Quick Order the default account destination without editing the
  theme-owned header snippets (header-secondary-area / header-mobile-menu),
  which a Fuel Themes update would overwrite.

  - Signed out: login links return to Quick Order after sign-in.
    (Quick Order forwards non-dealers to /pages/shop.)
  - Signed in: "My account" opens the account pages (Order History /
    Profile); menu items labelled "Login" are hidden.

  Config comes from window.SSDealerLinks, printed in layout/theme.liquid.
*/
(function () {
  'use strict';
  var cfg = window.SSDealerLinks;
  if (!cfg || !cfg.quickOrderUrl) return;

  var loginTarget = '/customer_authentication/login?return_to=' + encodeURIComponent(cfg.quickOrderUrl);

  function normalize(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.origin === window.location.origin ? url.pathname + url.search : url.href;
    } catch (e) {
      return href;
    }
  }

  var loginHrefs = (cfg.loginUrls || []).map(normalize);

  function rewrite() {
    document.querySelectorAll('a[href]').forEach(function (a) {
      var href = normalize(a.getAttribute('href'));
      if (!cfg.signedIn && loginHrefs.indexOf(href) !== -1) {
        a.setAttribute('href', loginTarget);
      } else if (cfg.signedIn && /^(log ?in|sign ?in)$/i.test(a.textContent.trim())) {
        // Signed in: drop the "Login" menu item (DEALERS dropdown, mobile menu, footer)
        var item = a.closest('li') || a;
        item.hidden = true;
        item.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewrite);
  } else {
    rewrite();
  }
  document.addEventListener('shopify:section:load', rewrite);

  // "Start shopping" / "Continue shopping" (cart drawer + cart page) point at the
  // old /collections/all or the homepage. The drawer re-renders, so catch the click instead of
  // rewriting the link: send it to the Shop page.
  // capture phase on window, so it runs before the theme's own link handlers
  window.addEventListener('click', function (event) {
    var a = event.target.closest && event.target.closest('a[href]');
    if (!a) return;
    var path = a.getAttribute('href').split('?')[0].replace(/\/$/, '');
    var label = (a.textContent || '').trim();
    if (/(^|\/)collections\/all$/.test(path) || /^(continue|start) shopping$/i.test(label)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = '/pages/shop';
    }
  }, true);
})();
